import { Pipe, PipeTransform } from '@angular/core';
import { AnomalyService } from 'src/app/common-modules/common-anomalies/services/common-anomalies.service';

@Pipe({
    name: 'clientAnomalyStageFormat',
    pure: true,
    standalone: false
})
export class ClientAnomalyStageFormatPipe implements PipeTransform {
  constructor(private anomalyService: AnomalyService) {}

  transform(row: any, ...args: unknown[]): string {
    return this.anomalyService.formatClientAnomalyStage(row);
  }
}